import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../../context/AuthContext';

const SCHALTER = [['bot_schutz', 'Schutz vor automatisierten Anfragen'], ['pflichtangaben', 'Pflichtangaben (Gegner, Schilderung, Frist)']];

export const MandatsanfragenRegeln = () => {
  const [r, setR] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get('/kanzlei/einstellungen/mandatsanfragen').then((x) => setR(x.data)).catch(() => setR(false)); }, []);
  if (r === null) return <Loader2 className="w-5 h-5 animate-spin text-[#b8893d]" />;
  if (!r) return <p className="text-xs text-rose-700">Einstellungen konnten nicht geladen werden.</p>;
  const gebiet = (g) => setR({ ...r, betreut: r.betreut.includes(g) ? r.betreut.filter((x) => x !== g) : [...r.betreut, g] });
  const speichern = async () => {
    setBusy(true);
    try { const x = await api.put('/kanzlei/einstellungen/mandatsanfragen', r); setR(x.data); toast.success('Gespeichert'); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Speichern fehlgeschlagen'); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-5" data-testid="mandatsanfragen-regeln">
      <div className="space-y-2">{SCHALTER.map(([k, l]) => (
        <label key={k} className="flex items-center gap-2 text-sm text-[#1B3A5C]"><input type="checkbox" checked={!!r[k]} onChange={(e) => setR({ ...r, [k]: e.target.checked })} className="accent-[#b8893d]" data-testid={`regel-${k}`} />{l}</label>
      ))}</div>
      <div>
        <p className="text-[11px] tracking-[0.2em] uppercase text-gray-500 mb-2">Betreute Rechtsgebiete (Vorprüfung)</p>
        <div className="flex flex-wrap gap-2">{r.alle_gebiete.map((g) => (
          <button key={g} type="button" onClick={() => gebiet(g)} aria-pressed={r.betreut.includes(g)} data-testid={`regel-gebiet-${g}`}
            className={`h-8 px-3 rounded-full text-xs border transition-colors ${r.betreut.includes(g) ? 'bg-[#1B3A5C] text-white border-[#1B3A5C]' : 'bg-white text-[#1B3A5C] border-gray-200 hover:border-[#b8893d]'}`}>{g}</button>
        ))}</div>
      </div>
      <label className="block text-sm text-[#1B3A5C]">Nachlaufzeit nach Mandatsende (Portal nur lesen, Tage)
        <input type="number" min={0} max={730} value={r.nachlauf_tage} onChange={(e) => setR({ ...r, nachlauf_tage: e.target.value })} className="block mt-1 h-9 w-28 border border-gray-300 rounded-[10px] px-2 text-sm" data-testid="regel-nachlauf" />
      </label>
      <button type="button" disabled={busy} onClick={speichern} className="h-9 px-4 rounded-[10px] bg-[#1B3A5C] text-white text-sm disabled:opacity-50" data-testid="mandatsanfragen-speichern">Speichern</button>
    </div>
  );
};
